import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { LoanInterestRates } from 'src/app/Models/loanintrestrate';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-loanintrestrates',
  templateUrl: './loanintrestrates.component.html',
  styleUrls: ['./loanintrestrates.component.css']
})
export class LoanintrestratesComponent implements OnInit {

  formTitle = "Manage Loan Interest Rates";
  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  dataList = [];
  loadingRecords = true;
  sortValue: string = "desc";
  sortKey: string = "id";
  searchText: string = "";
  filterQuery: string = "";
  isFilterApplied: string = "default";
   logtext:string = "";
   pageSize2=10

  columns: string[][] =[ ["TYPE_NAME","Type Name"],["DURATION","Duration"],["INTEREST_RATE","Interest Rate"],["SEQUENCE_NO","Sequence No"]  ]

  //drawer Variables
  drawerVisible: boolean;
  drawerTitle: string;
  drawerData: LoanInterestRates = new LoanInterestRates();
  constructor(private api: ApiService,private message: NzNotificationService) { }
  ngOnInit() {
    this.search();

	this.logtext = 'OPENED - LoanInterestRates form KEYWORD[O - LoanInterestRates] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
  }
 // Basic Methods
 sort(sort: { key: string; value: string }): void {
  this.sortKey = sort.key;
  this.sortValue = sort.value;
  this.search(true);

}
  search(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }
    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
	
	this.logtext = 'Filter Applied - LoanInterestRates form"+ sort +" "+this.sortKey +" KEYWORD [F - LoanInterestRates] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //     });

    } catch (error) {
      sort = "";
    }
    console.log("search text:" + this.searchText);
    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)
      console.log("likeQuery" + likeQuery);
    }

	this.logtext = 'Filter Applied - LoanInterestRates form "+ likeQuery +" KEYWORD [F - LoanInterestRates] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //     });

    this.api.getAllLoanInterestRates(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery).subscribe(data => {
      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.dataList = data['data'];
    }, err => {
      console.log(err);
    });
  }
  //Drawer Methods
  get closeCallback() {
    return this.drawerClose.bind(this);
  }
  add(): void {
    this.drawerTitle = "Create New Loan Interest Rate";
    this.drawerData = new  LoanInterestRates();
    this.drawerVisible = true;

	this.logtext = 'ADD - LoanInterestRates form KEYWORD [A - LoanInterestRates] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //     });

  }
  edit(data:  LoanInterestRates): void {

    this.drawerTitle = "Update Loan Interest Rate";
    this.drawerData = Object.assign({}, data);
    this.drawerVisible = true;

	this.logtext = 'EDIT - LoanInterestRates form KEYWORD [E - LoanInterestRates] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });


  }
  drawerClose(): void {
    this.search();
    this.drawerVisible = false;
  }

  
  publish(): void {

    this.api.publish('loanInterestRates')
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.message.success("Page Published Successfully", "");
          window.open("http://krishnakoyanapatsanstha.com/interestrates.html", "_blank");
        }
        else {
          this.message.error("Failed to publish...", "");
        }
      });

  }


  preview(): void {

    this.api.preview('loanInterestRates')
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.message.success("Page Published Successfully", "");
          window.open("http://krishnakoyanapatsanstha.com/preview/interestrates.html", "_blank");
        }
        else {
          this.message.error("Failed to publish...", "");
        }
      });

  }
}